import React, { useEffect, useState } from "react";
import { Spin } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import { invoiceDate } from './../../Utils/function';
import { getRequest } from '../../Utils/AppApi';
import { useHistory } from "react-router-dom";

function Invoice(props) {
    const history = useHistory();
    const [idata, setData] = useState(props.data);
    const [isPrintButton, setPrintButton] = useState(true);
    const [loading, setLoading] = useState(false);
    const { transactionId } = props;

    useEffect(() => {
        if (transactionId && !props.data) {
            setLoading(true);
            getRequest(`/bbps-im-wallet/transaction-detail?transactionId=${transactionId}`, history)
                .then(response => {
                    if (response.success && response.data && response.data.transaction) {
                        const tx = response.data.transaction;
                        const billData = tx.billData || {};
                        const imResponse = tx.imWalletResponse || {};
                        const transformed = {
                            customerName: billData.customerName,
                            customerPhoneNumber: tx.mobile,
                            accountNumber: tx.accountNumber,
                            category: tx.category,
                            txtId: tx.fetchTransactionId,
                            txnReferenceId: imResponse.imwtid,
                            billerReferenceNumber: imResponse.oprID,
                            billFetchId: tx.billFetchId,
                            billerName: tx.operatorName,
                            billedAmount: billData.billedamount,
                            paidAmount: tx.paidAmount,
                            dueDate: billData.dueDate,
                            billDate: billData.billdate,
                            txnStatus: tx.status === 3 ? 'PAYMENT_SUCCESS' : (tx.status === 2 ? 'PENDING' : 'PAYMENT_FAILURE'),
                            imWalletResponse: imResponse, // ✅ carry the full object through
                        };
                        setData(transformed);
                    } else {
                        console.error("Failed to fetch invoice data");
                    }
                })
                .catch(err => console.error(err))
                .finally(() => setLoading(false));
        } else if (props.data) {
            setData(props.data);
        }
    }, [transactionId, props.data, history]);

    const handlePrint = () => {
        setPrintButton(false);
        // Small delay so the button is hidden before print dialog opens
        setTimeout(() => {
            window.print();
            setPrintButton(true);
        }, 150);
    };

    const getStatusClass = (status) => {
        const statusMap = {
            'PAYMENT_SUCCESS': 'text-success fw-bold',
            'PAYMENT_PENDING': 'text-warning fw-bold',
            'PAYMENT_FAILURE': 'text-danger fw-bold'
        };
        return statusMap[status] || 'text-muted fw-bold';
    };

    const displayStatus = idata?.txnStatus ? (
        <span className={getStatusClass(idata.txnStatus)}>
            {idata.txnStatus.replace(/_/g, ' ')}
        </span>
    ) : (
        <span className="text-muted">Unknown</span>
    );

    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: '40px' }}>
                <Spin size="large" tip="Loading receipt..." />
            </div>
        );
    }

    if (!idata) {
        return <div className="container px-0">Loading invoice...</div>;
    }

    return (
        <div className="bbps-invoice-container" style={{ maxWidth: '800px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
            <style>{`
                /* ========== Screen styles ========== */
                .bbps-invoice-container {
                    padding: 20px;
                    background: white;
                }
                .bbps-invoice-header {
                    text-align: center;
                    margin-bottom: 20px;
                    border-bottom: 2px solid #C9262C;
                    padding-bottom: 10px;
                }
                .bbps-invoice-header h3 {
                    margin: 5px 0;
                    color: #C9262C;
                }
                .bbps-invoice-header p {
                    margin: 0;
                    font-size: 12px;
                    color: #666;
                }
                .bbps-invoice-section {
                    margin-bottom: 20px;
                }
                .bbps-invoice-section h4 {
                    background: #f5f5f5;
                    padding: 8px 12px;
                    margin: 0 0 10px 0;
                    font-size: 14px;
                    border-left: 3px solid #C9262C;
                }
                .bbps-info-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 15px;
                }
                .bbps-info-card {
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    padding: 10px;
                }
                .bbps-info-row {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 8px;
                    font-size: 13px;
                }
                .bbps-info-label {
                    font-weight: 600;
                    color: #555;
                }
                .bbps-info-value {
                    color: #333;
                }
                .bbps-transaction-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 10px;
                }
                .bbps-transaction-table th,
                .bbps-transaction-table td {
                    border: 1px solid #ddd;
                    padding: 8px;
                    text-align: left;
                    font-size: 13px;
                }
                .bbps-transaction-table th {
                    background: #f5f5f5;
                    font-weight: 600;
                }
                .bbps-amount-highlight {
                    font-weight: bold;
                    color: #C9262C;
                }
                .bbps-footer {
                    margin-top: 20px;
                    text-align: center;
                    border-top: 1px solid #ddd;
                    padding-top: 15px;
                    font-size: 11px;
                    color: #888;
                }
                .bbps-print-btn {
                    background: #C9262C;
                    color: white;
                    border: none;
                    border-radius: 40px;
                    padding: 8px 20px;
                    cursor: pointer;
                    margin-top: 15px;
                }

                /* ========== Print styles – key fixes ========== */
                @media print {
                    /* 1. Hide EVERYTHING on the page by default */
                    body * {
                        visibility: hidden;
                    }

                    /* 2. Show only the invoice and its children */
                    .bbps-invoice-container,
                    .bbps-invoice-container * {
                        visibility: visible;
                    }

                    /* 3. Position the invoice at the top-left of the printed page */
                    .bbps-invoice-container {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        max-width: 100%;
                        margin: 0;
                        padding: 15px;
                        background: white !important;
                        box-shadow: none !important;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }

                    /* 4. Hide the print button */
                    .bbps-print-btn {
                        display: none !important;
                    }

                    /* 5. Clean up page margins & background */
                    @page {
                        margin: 12mm;
                        size: A4;
                    }

                    html, body {
                        background: white !important;
                        margin: 0 !important;
                        padding: 0 !important;
                        height: auto !important;
                    }

                    /* 6. Prevent cards/tables from breaking across pages */
                    .bbps-info-card,
                    .bbps-transaction-table,
                    .bbps-invoice-section {
                        break-inside: avoid;
                        page-break-inside: avoid;
                    }

                    .bbps-transaction-table th,
                    .bbps-transaction-table td {
                        border: 1px solid #ccc;
                    }
                }

                @media (max-width: 600px) {
                    .bbps-info-grid {
                        grid-template-columns: 1fr;
                    }
                }
            `}</style>

            {/* Header */}
            <div className="bbps-invoice-header">
                <img
                    src="../bbps/b_assured_logo.png"
                    alt="Bharat BillPay"
                    style={{ height: '50px', marginBottom: '5px' }}
                />
                <h3>Payment Receipt</h3>
                <p>Generated on {invoiceDate(new Date())}</p>
            </div>

            {/* Transaction Summary */}
            <div className="bbps-invoice-section">
                <h4>Transaction Summary</h4>
                <div className="bbps-info-grid">
                    <div className="bbps-info-card">
                        <div className="bbps-info-row">
                            <span className="bbps-info-label">Customer Name:</span>
                            <span className="bbps-info-value">{idata.customerName || 'N/A'}</span>
                        </div>
                        <div className="bbps-info-row">
                            <span className="bbps-info-label">Mobile Number:</span>
                            <span className="bbps-info-value">{idata.customerPhoneNumber || 'N/A'}</span>
                        </div>
                        <div className="bbps-info-row">
                            <span className="bbps-info-label">Account Number:</span>
                            <span className="bbps-info-value">{idata.accountNumber || 'N/A'}</span>
                        </div>
                        <div className="bbps-info-row">
                            <span className="bbps-info-label">Category:</span>
                            <span className="bbps-info-value">{idata.category || 'N/A'}</span>
                        </div>
                    </div>
                    <div className="bbps-info-card">
                        <div className="bbps-info-row">
                            <span className="bbps-info-label">Order Number:</span>
                            <span className="bbps-info-value">{idata.txtId || 'N/A'}</span>
                        </div>
                        <div className="bbps-info-row">
                            <span className="bbps-info-label">Transaction ID:</span>
                            <span className="bbps-info-value">{idata.txnReferenceId || 'N/A'}</span>
                        </div>
                        <div className="bbps-info-row">
                            <span className="bbps-info-label">Biller Reference:</span>
                            <span className="bbps-info-value">{idata.billerReferenceNumber || 'N/A'}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bill Details */}
            <div className="bbps-invoice-section">
                <table className="bbps-transaction-table">
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th>Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Biller Name</td>
                            <td>{idata.billerName || 'N/A'}</td>
                        </tr>
                        <tr>
                            <td>Billed Amount</td>
                            <td className="bbps-amount-highlight">
                                ₹{parseFloat(idata.billedAmount || 0).toFixed(2)}
                            </td>
                        </tr>
                        <tr>
                            <td>Amount Paid</td>
                            <td className="bbps-amount-highlight">
                                ₹{parseFloat(idata.paidAmount || 0).toFixed(2)}
                            </td>
                        </tr>
                        <tr>
                            <td>Due Date</td>
                            <td>{idata.dueDate || 'N/A'}</td>
                        </tr>
                        <tr>
                            <td>Bill Date</td>
                            <td>{idata.billDate || 'N/A'}</td>
                        </tr>
                        <tr>
                            <td>Status</td>
                            <td>{displayStatus}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Wallet response message (optional) */}
            {idata?.imWalletResponse?.msg && (
                <div className="bbps-invoice-section">
                    <h4>Remark : {idata.imWalletResponse.msg}</h4>
                </div>
            )}

            {/* Footer & Print Button */}
            {/* <div className="bbps-footer">
                <p>This is a computer-generated receipt and does not require a signature.</p>
                {isPrintButton && (
                    <button onClick={handlePrint} className="bbps-print-btn">
                        <PrinterOutlined /> Print Receipt
                    </button>
                )}
            </div> */}
        </div>
    );
}

export default Invoice;